<template>
  <div>
    <!-- 历史地址 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1580px" center>
      <div class="content">
        <!-- 添加新箱子 -->
        <div class="row">
          <div class="item">

            <div class="val">
              <el-input v-model="datas.keyword" onfocus="this.select()" type="text" placeholder="历史配送单号"></el-input>
            </div>
          </div>
          <div class="item">
            <div class="label">

            </div>
            <div class="val">
              <el-input v-model="datas.keyword" onfocus="this.select()" type="text" placeholder="  地址-氏名："></el-input>
            </div>
          </div>
          <el-button type="primary" @click="historyDeliveryAddressList">搜索</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 会社 -->
            <li>
              会社
            </li>
            <li>
              会社名（ローマ字）
            </li>
            <!-- 郵便 -->
            <li>
              郵便
            </li>
            <!-- 住所 -->
            <li>
              住所
            </li>
            <!-- 住所(ローマ字) -->
            <li>
              住所(ローマ字)
            </li>
            <!-- 氏名 -->
            <li>
              氏名
            </li>
            <!-- 氏名(ローマ字) -->
            <li>
              氏名(ローマ字)
            </li>
            <!-- 携帯番号 -->
            <li>
              携帯番号
            </li>
            <!-- 固定電話 -->
            <li>
              固定電話
            </li>
            <!-- 法人番号 -->
            <li>
              法人番号
            </li>
            <!-- リアルタイム口座 -->
            <li>
              リアルタイム口座
            </li>
            <!-- 標準コード -->
            <li>
              標準コード
            </li>
            <!-- 操作q -->
            <li>
              操作
            </li>
          </ol>
          <ul v-for="item in tableData" :key="item.id">
            <!-- 会社 -->
            <li>
              {{ item.company }}
            </li>
            <li>
              {{ item.company_roma }}
            </li>
            <!-- 郵便 -->
            <li>
              {{ item.zip_code }}
            </li>
            <!-- 住所 -->
            <li>
              {{ item.address }}
            </li>
            <!-- 住所(ローマ字) -->
            <li>
              {{ item.address_roma }}
            </li>
            <!-- 氏名 -->
            <li>
              {{ item.contacts }}
            </li>
            <!-- 氏名(ローマ字) -->
            <li>
              {{ item.contacts_roma }}
            </li>
            <!-- 携帯番号 -->
            <li>
              {{ item.mobile }}
            </li>
            <!-- 固定電話 -->
            <li>
              {{ item.tel }}
            </li>
            <!-- 法人番号 -->
            <li>
              {{ item.tax_no }}
            </li>
            <!-- リアルタイム口座 -->
            <li>
              {{ item.bank_no }}
            </li>
            <!-- 標準コード -->
            <li>
              {{ item.standard_no }}
            </li>
            <!-- 操作 -->
            <li>
              <el-button type="primary" size="mini" @click="useAddress(item)">使用</el-button>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      receiver: (state) => state.porderDetail.receiver,
      importer: (state) => state.porderDetail.importer,

    }),
  },
  data() {
    return {
      title: '',
      datas: {
        keyword: "",
        porder_sn: '',
        type: '',
      },
      tableData: [],
      dialogVisible: false,
    };
  },
  methods: {
    // 历史地址-列表
    historyDeliveryAddressList() {
      this.$api.porderApi.historyDeliveryAddressList(this.datas).then(res => {
        this.tableData = res.data
      })
    },
    // 使用地址
    useAddress(item) {
      for (let key in item) {
        if (this.datas.type == 1) {
          this.importer[key] = item[key]
        } else {
          this.receiver[key] = item[key]
        }
      }
      this.dialogVisible = false
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .item {
      width: 220px;
      margin-right: 20px;
    }
  }

  .table {
    border: 1px solid #edeff4;
    max-height: 600px;
    overflow: auto;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;


      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }



  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>
